import { useAppContext } from '../../appProvider/contextProvider';

const PaymentSuccess = () => { 

    const { refetchProfile, 
        isPaymentSuccess,
        setCardSuccess,
        setPaymentSuccess,
        refetchFeatures,
        isCardSuccess, 
        isUpdatePlanSuccess,
        setUpdatePlanSuccess,
        isCancelPlanSuccess,
        setCancelPlanSuccess,
        refetchWebsites,
    } = useAppContext();

        const onOk = () => {
            refetchProfile();
            refetchFeatures();
            refetchWebsites();
            setCardSuccess(false);
            setPaymentSuccess(false);
            setUpdatePlanSuccess(false);
            setCancelPlanSuccess(false)
        }

    const getSuccessMessage = () => {
        if(isPaymentSuccess) {
            return 'Payment Success';
        } else if(isCardSuccess) {
            return 'Your card details have been updated successfully!!';
        } else if(isUpdatePlanSuccess) {
            return 'Your plan has been updated successfully!!';
        } else if(isCancelPlanSuccess) {
            return 'Your plan has been cancelled successfully!!';
        }
    }
 
return <> 
    <div className="modal fade show modal-center" tabindex="-1">
        <div className="modal-dialog modal-sm">
        <div className="modal-content">
            <div className="modal-body">
                <div className="d-flex flex-column p-2 align-items-center text-center">
                    <i className='icon icon-check icon-2x sucess-check mb-2'></i>
                    {/* <i className='icon icon-close icon-2x failure-check'></i> */}
                    <label className="form-label text-dark medium mb-2">{getSuccessMessage()}</label>
                    <div className="text-center">
                        <button className="btn btn-success" onClick={onOk} >OK</button>
                    </div>
                </div>                    
            </div>
        </div>
        </div>
    </div>
    <div className="modal-backdrop fade show"></div>
</>

}
export default PaymentSuccess;